import { Link } from "react-router-dom";

import { investorImages } from "./investorImages";

import countries from "../../constants/countries.json";
import InvestmentPoolChart from "./InvestorPoolChart";

export const investorPoolCompanies = [
  {
    id: 1,
    name: "Winasa Ceramica",
    address:
      "second floor, shop no 207, pacific, business park, mahendranagar, chokadi, mahendranagar morbi, india, in",
    countryFlag: "IN",
    website: "http://www.winasaceramica.com",
    insuredDate: "11/10/2025",
    annualRevenue: "$30,000,000",
    creditLimit: "$2,500,000",
    screenShots: investorImages.winasa,
  },
  {
    id: 2,
    name: "Asia Pacific Impex",
    address:
      "asia pacific impex s-10hemratna chember near traj par chokdi 8-a national highway morbi-363642 gujarat india",
    countryFlag: "IN",
    website: "https://www.asiapacificceramic.com",
    insuredDate: "11/18/2025",
    annualRevenue: "$10,000,000",
    creditLimit: "$2,000,000",
    screenShots: investorImages.apImpex,
  },
  {
    id: 3,
    name: "Geonix International",
    address: "203-204, deepali building-92nehru place, In",
    website: "http://www.geonix.in",
    countryFlag: "IN",
    insuredDate: "11/18/2025",
    annualRevenue: "$32,000,000",
    creditLimit: "$1,800,000",
    screenShots: investorImages.geonix,
  },
  {
    id: 4,
    name: "Surya Roshni Ltd",
    address: "p-1 to p-20, ghirongiindustrial area, malanpur, In",
    website: "https://www.surya.co.in",
    countryFlag: "IN",
    insuredDate: "12/11/2025",
    annualRevenue: "$9,000,000",
    creditLimit: "$1,000,000",
    screenShots: investorImages.surya,
  },
];

export default function PoolSummary() {
  return (
    <div className="rounded-xl bg-white p-6 shadow-sm">
      {/* Header */}
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">
          Investor Pool Summary
        </h2>
      </div>

      <div className="flex gap-8">
        {/* Chart */}
        <InvestmentPoolChart />

        {/* Vertical Divider */}
        <div className="w-px self-stretch bg-gray-200" />

        {/* Table */}
        <div className="w-full overflow-x-auto">
          <table className="min-w-full table-auto text-left">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">
                  Customer Name
                </th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">
                  Location
                </th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">
                  Insured Date
                </th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">
                  Annual Revenue
                </th>
                <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600">
                  Credit Limit
                </th>
              </tr>
            </thead>

            <tbody>
              {investorPoolCompanies.map((company) => {
                return (
                  <tr
                    key={company.id}
                    className="border-b border-gray-100 transition hover:bg-gray-50"
                  >
                    <td className="px-4 py-3 text-sm font-medium text-gray-900">
                      <Link
                        to={`/investor/investor-details/${company.id}`}
                        className="hover:text-blue-600"
                      >
                        {company.name}
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      <div className="flex items-center gap-1 px-2 py-0.5">
                        <img
                          className="h-4 w-4"
                          src={
                            countries.find(
                              (el) => el.iso2 === company.countryFlag
                            )?.flag
                          }
                          alt="flag"
                        />
                        <span className="text-xs text-gray-600">
                          {company.countryFlag}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {company.insuredDate}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-700">
                      {company.annualRevenue}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-900">
                      {company.creditLimit}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
